import DataModelDesigner from './DataModelDesigner';
import { entities, mockData} from '../../mock/data-model/Customer360';

export default function Customer360Page({ engagementId }) {
  return <DataModelDesigner title="Customer 360" engagementId={engagementId}  entities={entities} mockData={mockData} />;
}
